import { TemplateRef, Directive } from '@angular/core';

@Directive({
    selector: '[aaTabContent]',
    standalone: false
})
export class TabContentDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
